const DEFAULT_API_ORIGIN = 'https://api.freespot.dk';

const explicitApiUrl = process.env.REACT_APP_API_URL?.trim();
const environmentName = process.env.REACT_APP_ENVIRONMENT || 'production';
const isLocalApiUrl = (value?: string) =>
  !!value && /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(value);

const useSameOriginApi =
  environmentName === 'production' ||
  !explicitApiUrl ||
  isLocalApiUrl(explicitApiUrl);

const environment = {
  apiUrl: useSameOriginApi ? '' : explicitApiUrl || DEFAULT_API_ORIGIN,
  backendOrigin: explicitApiUrl || DEFAULT_API_ORIGIN,
  useSameOriginApi,
  environment: environmentName,
  appName: process.env.REACT_APP_APP_NAME || 'FreeSpot Admin',
  isDevelopment: environmentName === 'development',
  isProduction: environmentName === 'production',
};

export default environment;
